import axios from 'axios';

// ✅ FIX: Add a hardcoded fallback if process.env is missing
const rawUrl = process.env.REACT_APP_API_URL;
export const API_BASE_URL = rawUrl.replace('/api', '');

// Create a single, central Axios instance for your entire application.
const apiService = axios.create({
  baseURL: rawUrl,
  headers: { 'Content-Type': 'application/json' },
});

// Automatically attach the user's authentication token to every request.
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('customer_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- AUTH FUNCTIONS ---
export const signUp = (formData) => apiService.post('/auth/signup', formData);
export const login = (credentials) => apiService.post('/auth/login', credentials);
export const verifyOtp = (otpData) => apiService.post('/auth/verify-otp', otpData);
// export const getProfile = () => apiService.get('/auth/profile');
export const getProfile = (token) => {
    const authToken = token || localStorage.getItem('customer_token');
    if (!authToken || authToken === 'null' || authToken === 'undefined') {
        return Promise.reject(new Error('Authentication token is missing.'));
    }
    return apiService.get('/auth/profile', {
        headers: {
            Authorization: `Bearer ${authToken}`
        }
    });
};
export const updateUserProfile = (profileData) => apiService.patch('/user/profile', profileData);
export const changeUserPassword = (passwordData) => apiService.post('/auth/change-password', passwordData);
export const verifyFirebaseOtp = (tokenData) => apiService.post('/auth/verify-firebase', tokenData);

// +++ NEW API FUNCTIONS +++
export const sendVerificationEmail = (email) => apiService.post('/auth/send-verification-email', { email });
export const verifyEmailActivationOtp = (email, otp) => apiService.post('/auth/verify-email-otp', { email, otp });
export const sendPhoneResetOtp = (phone) => apiService.post('/auth/send-password-reset-phone-otp', { phone });
export const verifyPhoneResetOtp = (phone, otp) => apiService.post('/auth/verify-password-reset-phone-otp', { phone, otp });
// +++ END NEW API FUNCTIONS ---

// --- USER ADDRESS FUNCTIONS ---
export const getAddresses = () => apiService.get('/address');
export const addAddress = (addressData) => apiService.post('/address', addressData);
export const updateAddress = (addressId, addressData) => apiService.put(`/address/${addressId}`, addressData);
export const deleteAddress = (addressId) => apiService.delete(`/address/${addressId}`);

// --- VENDOR & SEARCH FUNCTIONS ---
export const fetchRestaurants = () => apiService.get('/restaurants');
export const fetchRestaurantById = (id) => apiService.get(`/restaurants/${id}`);
export const fetchGroceryStores = () => apiService.get('/grocery-stores');
export const fetchGroceryStoreById = (id) => apiService.get(`/grocery-stores/${id}`);
export const fetchCloudKitchens = () => apiService.get('/cloudkitchens');
export const fetchCloudKitchenById = (id) => apiService.get(`/cloudkitchens/${id}`);
export const searchVendors = (query) => apiService.get('/search', { params: { q: query } });
export const getCrossSellItems = (vendorType, vendorId) => {
  const apiPath = vendorType === 'restaurant' ? 'restaurants' : 'cloudkitchens';
  return apiService.get(`/${apiPath}/${vendorId}/cross-sell-items`);
};

// --- CART FUNCTIONS ---
export const getCart = (identifier) => apiService.get('/cart', { params: identifier });
export const addToCart = (cartData) => apiService.post('/cart/add', cartData);
export const updateCartItemQuantity = (updateData) => apiService.patch('/cart/update-item-quantity', updateData);
export const clearCart = (identifier) => apiService.delete('/cart/clear', { params: identifier });
export const deleteGuestCart = (data) => apiService.post('/cart/delete-guest-cart', data);

// --- ORDER FUNCTIONS ---
export const placeOrderOnline = (orderData) => apiService.post('/orders/place-online', orderData);
export const placeRazorpayOrder = (orderData) => apiService.post('/orders/place-razorpay-order', orderData);
export const verifyStripePayment = (orderId, success) => apiService.post('/orders/verify', { orderId, success });
export const verifyRazorpayPayment = (paymentData) => apiService.post('/orders/verify-razorpay-payment', paymentData);
export const getUserOrders = () => apiService.get('/orders/user-orders');
export const getOrderById = (orderId) => apiService.get(`/orders/${orderId}`);
export const checkOrderById = (orderId) => apiService.get(`/orders/check/${orderId}`);
export const getGuestOrders = (email) => apiService.get('/orders/guest-orders', { params: { guestEmail: email } });
export const logPayment = (paymentData) => apiService.post('/payment/log', paymentData);

// ✅ NEW: Cancel Next-Day Order
export const cancelOrder = (orderId) => apiService.put(`/orders/${orderId}/cancel`);

// --- REVIEW FUNCTIONS ---
export const createReview = (reviewData) => apiService.post('/reviews', reviewData);
export const createDeliveryPersonReview = (reviewData) => apiService.post('/delivery-person-reviews', reviewData);

// --- GUEST OTP FUNCTIONS ---
export const verifyGuestFirebase = (data) => apiService.post('/auth/verify-guest-firebase', data);

// --- NEW: Cart Totals Calculation Function ---
export const calculateCartTotals = (payload) =>
  apiService.post('/orders/cart-totals', payload) 
    .then(res => res.data);

export default apiService;
